import { useState, type FormEvent } from "react";
import type { SessionResponse } from "../../shared/api";
import { AuthLayout, type VersionInfo } from "@/components/Brand";
import { ErrorAlert } from "@/components/ErrorAlert";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { errorText, login } from "@/lib/client";

export function LoginScreen({ onLogin, company, version }: { company?: string | null; version?: VersionInfo | null; onLogin: (s: SessionResponse) => void }) {
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    setBusy(true);
    setError("");
    try {
      onLogin(await login({ username: String(f.get("username")), password: String(f.get("password")) }));
    } catch (err) {
      setError(errorText(err));
      setBusy(false);
    }
  }

  return (
    <AuthLayout company={company} version={version}>
      <h1 className="text-2xl font-semibold tracking-tight">Giriş yap</h1>
      <form onSubmit={submit} className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Label htmlFor="username">Kullanıcı adı</Label>
          <Input id="username" name="username" autoComplete="username" required autoFocus />
        </div>
        <div className="flex flex-col gap-2">
          <Label htmlFor="password">Parola</Label>
          <Input id="password" name="password" type="password" autoComplete="current-password" required />
        </div>
        {error && <ErrorAlert>{error}</ErrorAlert>}
        <Button type="submit" disabled={busy}>{busy ? "Giriş yapılıyor…" : "Giriş yap"}</Button>
      </form>
    </AuthLayout>
  );
}
